function clear(canvas: HTMLCanvasElement): void {
    // If there is no element canvas
    if (!(canvas instanceof HTMLCanvasElement)) {
        console.error('Is not an element canvas...');
        return;
    }

    // Get context
    const context = canvas.getContext('2d');

    if (context == null) {
        return;
    }

    // Clear
    context.clearRect(0, 0, canvas.width, canvas.height);
}

export { clear };
